import React, { Component } from "react";
import { Chart, registerables, Colors } from "chart.js";

import "./Diagram.css";

class Diagram extends Component {
    constructor(props) {
        super(props);
        this.canvasRef = React.createRef();
        this.drawChart = this.drawChart.bind(this);
        Chart.register(...registerables, Colors);
    }

    chart;

    drawChart() {
        let { selected_category, categories, mode, set_cat } = this.props;

        let data =
            selected_category != null
                ? categories[selected_category].items.map((item) => {
                      return { name: item.name, value: item[mode] };
                  })
                : categories.map((cat) => {
                      return {
                          name: cat.name,
                          value: cat.items.reduce((a, b) => {
                              return a + (b[mode] || 0);
                          }, 0),
                      };
                  });

        data = {
            labels: data.map((data) => data.name),
            datasets: [
                {
                    label:
                        mode == "sold_count" ? "   مقدار فروش  " : "  بازدید  ",
                    data: data.map((data) => data.value),
                    backgroundColor: [
                        "rgba(151,187,205,.9)",
                        "rgba(70,191,189,.9)",
                        "rgba(220,220,220,.9)",
                        "rgba(148,159,177,.9)",
                        "rgba(247,70,74,.9)",
                        "rgba(253,180,92,.9)",
                        "rgba(77,83,96,.9)",
                    ],
                },
            ],
        };

        if (this.chart) {
            this.chart.destroy();
        }

        this.chart = new Chart(this.canvasRef.current, {
            type: "bar",
            data,
            options: {
                responsive: true,
                plugins: {
                    legend: {
                        position: "top",
                    },
                    title: {
                        display: true,
                        text:
                            selected_category != null
                                ? categories[selected_category].name
                                : "دسته بندی ها",
                    },
                },
                onClick: (e, clicked) => {
                    let el = clicked[0];
                    selected_category == null && el && set_cat(el.index);
                },
            },
        });
    }

    componentDidMount() {
        this.componentDidUpdate();
    }

    componentDidUpdate(prevProps) {
        let {
            selected_category: prev_selected_category,
            categories: prev_categories,
            mode: prev_mode,
        } = prevProps || {};

        let { selected_category, categories, mode } = this.props;
        if (
            selected_category != prev_selected_category ||
            categories != prev_categories ||
            mode != prev_mode
        ) {
            this.drawChart();
        }
    }

    state = {};
    render() {
        let { selected_category, set_cat } = this.props;

        return (
            <div className="DiagramComponent">
                {selected_category != null && (
                    <button
                        className="btn info"
                        onClick={(ev) => {
                            set_cat(null);
                        }}
                    >
                        برگشت به حالت دسته بندی ها
                    </button>
                )}
                <canvas ref={this.canvasRef}></canvas>
            </div>
        );
    }
}

export default Diagram;
